<template>
  <div class="game-points">
    <pageHeader
      whiteIcon
      title="转游积分"
      bgColor="transparent"
      color="#FFFFFF"
    />
    <div class="point-container">
      <div class="point-box">
        <div class="my-point">
          <span class="point-number">{{pointNumber}}</span>
          <span class="point-label">我的积分</span>
        </div>

        <div class="exchange-points">
          <div class="exchage-title">
            <img src="@/assets/images/point-icon3.png/" alt="" />
            <h1>积分兑换</h1>
            <span class="undeline-box"></span>
          </div>

          <div class="exchange-box">
            <van-field
              class="exchange-amount"
              v-model="exchangeValue"
              input-align="center"
              placeholder="请输入兑换金额"
              type="digit"
              @input="onInput"
            />

            <div class="exchange-btn" @click="exchange">立即兑换</div>
            <div class="btn-model"></div>
          </div>
        </div>
      </div>

      <div class="exchange-instructions">
        <div class="exchage-title">
          <img src="@/assets/images/point-icon2.png/" alt="" />
          <h1>兑换说明</h1>
          <span class="undeline-box"></span>
        </div>

        <div class="exchange-desc">
          <span
            >1、在充值记录处，点击转盘抽奖即可获得积分；
            <em class="prize-draw" @click="goToRechargeRecord">立即前往</em></span
          >
          <span>2、积分兑换首充优惠券，仅限首充使用，有效期3天； </span>
          <span
            >3、优惠券使用门槛为面额的1.5倍，即兑换10元优惠券，实际活的满15-10元优惠券；</span
          >
        </div>
      </div>

      <div class="exchange-instructions btm-30">
        <div class="exchage-title">
          <img src="@/assets/images/point-icon2.png/" alt="" />
          <h1>兑换记录</h1>
          <span class="undeline-box"></span>
        </div>

        <div class="exchange-table">
          <div class="table-thead">
            <div class="thead-th">
              <span>时间</span>
              <span class="block-box"></span>
            </div>
            <div class="thead-th">
              <span>类别</span>
              <span class="block-box"></span>
            </div>
            <div class="thead-th">
              <span>积分变动</span>
              <span class="block-box"></span>
            </div>
            <div class="thead-th">
              <span>剩余积分</span>
              <span class="block-box"></span>
            </div>
          </div>
          <div class="table-tbody">
            <div class="tbody-tr" v-for="(item, i) in exchangeList" :key="i">
              <div class="tbody-td">
                <span>{{ item.createTime | timeFormat }}</span>
              </div>
              <div class="tbody-td">
                <span>{{ item | typeFormat }}</span>
              </div>
              <div class="tbody-td">
                <span>{{ item.score }}</span>
              </div>
              <div class="tbody-td">
                <span>{{ item.afterScore }}</span>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  data() {
    return {
      exchangeList: [],
      currentPage: 1,
      pageSize: 9999,
      exchangeValue: "",
      pointNumber: 0,
      dialogText: "",
    };
  },
  filters: {
    timeFormat(val) {
      return val.split(" ")[0];
    },
    typeFormat(info) {
      const val = info.type;
      if (val == "DRAW_SCORE") {
        return "积分抽奖";
      } else if (val == "RECHARGE") {
        return "充值获得";
      } else if (val == "SEND") {
        return "人工发放";
      } else {
        return `满${info.enableAmount}-${info.amount}`;
      }
    },
  },
  mounted() {
    this.getScoreInfo();
    this.fetchScoreLogList();
  },
  methods: {
    onInput(value) {
      // 使用正则表达式验证输入的值
      const regex = /^[1-9]\d*$/; // 匹配正整数
      if (regex.test(value) || value === '') {
        this.exchangeValue = value; // 只更新符合条件的值
      } else {
        this.exchangeValue = ''
        // 如果输入不符合条件，可以选择显示提示或清空输入框
        this.$toast.fail('请输入正整数');
      }
    },
    /**
     * 积分兑换记录
     */
    async fetchScoreLogList() {
      try {
        const { data } = await requestMethods(
          "/modules/score/score/fetchScoreLogList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        this.exchangeList = data.map(e => {
          return {
            ...e,
            score: Math.sign(e.score) == 1 ? `+${e.score}` : e.score,
            
          }
        }) || [];
      } catch (err) {
        this.$toast(err.message);
      }
    },
    /**
     * 获取我的积分
     */
    async getScoreInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/score/score/getScoreInfo.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.pointNumber = data.score;
      } catch (err) {
        this.$toast(err.message);
      }
    },

    /**
     * 兑换积分提示文案
     */
    async getExchangeInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/score/score/getExchangeInfo.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            money: this.exchangeValue,
          }
        );
        const { score, amount, enableAmount } = data;
        this.dialogText =
          "本次兑换消耗" +
          score +
          "积分，获得1张满" +
          Math.floor(enableAmount) +
          "-" +
          amount +
          "转游券，仅限<em style='font-weight: 600'>首充</em>使用。确定兑换？";
      } catch (err) {
        this.$toast(err.message);
      }
    },
    /**
     * 积分兑换优惠券
     */
    async scoreExchange() {
      try {
        await requestMethods("/modules/score/score/scoreExchange.htm", "post", {
          uuid: this.uuid,
          appType: "WM",
          money: this.exchangeValue,
        });
        this.$toast("兑换成功");
      } catch (err) {
        this.$toast(err.message);
      }
    },

    async exchange() {
      if (!this.exchangeValue) {
        this.$toast("请输入兑换金额");
        return;
      }
      await this.getExchangeInfo();
      this.$dialog
        .confirm({
          title: "",
          width: "280px",
          message: this.dialogText,
          confirmButtonColor: "#FF7A3E",
          beforeClose: this.beforeClose,
          dangerouslyUseHTMLString: true,
        })
        .then(async (res) => {
          await this.scoreExchange();
          this.exchangeValue = "";
          this.getScoreInfo();
          this.fetchScoreLogList();
        });
    },

    /**
     * 跳转到充值记录
     */
    goToRechargeRecord() {
      this.$router.push({ path: "/rechargeRecord" });
    },
  },
};
</script>

<style lang="scss">
.game-points {
  min-height: 100vh;
  background: #f8f8f8;
  .point-container {
    margin-top: -88px;

    .point-box {
      background: url("~@/assets/images/point-bg.png");
      background-size: 100% 100%;
      width: 100%;
      height: 800px;

      .my-point {
        padding-left: 84px;
        padding-top: 169px;
        span {
          display: block;
        }
        .point-number {
          font-family: Helvetica;
          font-size: 70px;
          color: #ffffff;
          line-height: 60px;
        }
        .point-label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #ffffff;
          line-height: 60px;
        }
      }

      .exchange-points {
        margin-top: 100px;
        .exchage-title {
          display: flex;
          align-items: center;
          position: relative;
          margin-left: 37px;

          img {
            width: 27px;
            height: 32px;
            margin-right: 5px;
          }
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 30px;
            color: #2b2b2b;
            line-height: 60px;
            z-index: 2;
          }
          .undeline-box {
            width: 121px;
            height: 14px;
            background: #ffe3d3;
            border-radius: 7px;
            opacity: 0.69;
            position: absolute;
            left: 35px;
            bottom: 8px;
          }
        }

        .exchange-box {
          width: 680px;
          // height: 280px;
          background: #ffffff;
          box-shadow: 0px 2px 20px 0px rgba(206, 206, 206, 0.18);
          border-radius: 16px;
          margin: 20px 35px;
          padding-top: 60px;
          padding-bottom: 42px;
          position: relative;

          .exchange-amount {
            width: 300px;
            margin: 0 auto;

            .van-field__control {
              color: #ff8441;
              border-bottom: 1px solid #cacaca;
            }
          }

          .exchange-btn {
            display: block;
            margin: 0 auto;
            width: 420px;
            height: 80px;
            background: #ff8441;
            border-radius: 40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 30px;
            color: #ffffff;
            line-height: 80px;
            text-align: center;
            position: relative;
            z-index: 2;
          }
          .btn-model {
            width: 420px;
            height: 80px;
            background: #ff8441;
            border-radius: 40px;
            opacity: 0.23;
            position: absolute;
            bottom: 34px;
            left: 130px;
          }
        }
      }
    }
    .exchange-instructions {
      margin-top: 8px;
      .exchage-title {
        display: flex;
        align-items: center;
        position: relative;
        margin-left: 37px;

        img {
          width: 27px;
          height: 32px;
          margin-right: 5px;
        }
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 30px;
          color: #2b2b2b;
          line-height: 60px;
          z-index: 2;
        }
        .undeline-box {
          width: 121px;
          height: 14px;
          background: #ffe3d3;
          border-radius: 7px;
          opacity: 0.69;
          position: absolute;
          left: 35px;
          bottom: 8px;
        }
      }

      .exchange-desc {
        width: 680px;
        background: #ffffff;
        box-shadow: 0px 2px 20px 0px rgba(206, 206, 206, 0.18);
        border-radius: 16px;
        margin: 20px 35px;
        padding: 25px 35px;
        position: relative;

        span {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #414141;
          line-height: 40px;
        }

        .prize-draw {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #ff7a3e;
          font-style: normal;
          text-decoration-line: underline;
        }
      }

      .exchange-table {
        width: 680px;
        background: #fff;

        margin: 0 auto;
        margin-top: 20px;
        padding: 20px;
        .table-thead {
          display: flex;
          justify-content: space-between;
          height: 80px;
          width: 680px;
          // margin: 0 20px;

          .thead-th {
            width: 170px;
            padding-top: 20px;
            border-bottom: 1px solid #f2f2f2;
            text-align: left;
          }

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #333333;
            line-height: 40px;
            display: block;
          }
          .block-box {
            width: 80px;
            height: 12px;
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0) 0%,
              #ffbead 100%
            );
            margin-top: -10px;
            margin-left: 0px;
          }
        }
        .table-tbody {
          // width: 680px;
          .tbody-tr {
            display: flex;
            justify-content: space-between;
            height: 80px;
            width: 680px;
            border-bottom: 1px solid #f2f2f2;

            span {
              width: 170px;
              display: block;
              line-height: 80px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #666666;
              text-align: left;
            }
          }
        }
      }
    }
    .btm-30 {
      padding-bottom: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/gamePoints/index.vue